import { widgetState } from '../../store/customizations/index'

export const dropdownTemplate = () => {
  return `
    <div class="yotpo-frequency-options" tabindex="1">
        {{#values}}
        <input class="yotpo-radio-and-dropdown-option" name="{{groupId}}" value="{{value}}" type="radio" id="{{id}}" {{#checked}}checked{{/checked}}>
        <label for="{{id}}" class="yotpo-radio-and-dropdown-label">{{label}}</label>
        {{/values}}
    </div>
    <style>
        .yotpo-widget-subscriptions-add-to-cart .yotpo-select-wrapper {
          height: 64px;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-options {
          display: flex;
          flex-direction: column;
          position: relative;
          border: 1px solid ${widgetState.customizations.styles.colors.text.primary};
          border-radius: 3px;
          background: white;
          height: fit-content;
          margin: 20px auto;
          margin-left: 28px;
          cursor: pointer;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-options:focus {
          box-shadow: 0 7px 7px rgba(0, 0, 0, 0.15);
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-and-dropdown-label {
          font-family: ${widgetState.customizations.styles.fontFamily.name};
          font-size: ${widgetState.customizations.styles.fontSize.primary};
          font-weight: ${widgetState.customizations.styles.fontFamily.weight || 400};
          color: ${widgetState.customizations.styles.colors.text.primary};
          font-style: normal;
          padding: 0 30px 0 10px;
          min-height: 40px;
          display: flex;
          align-items: center;
          background: ${widgetState.customizations.styles.selectedRadio.dropdownBackgroundColor};
          position: absolute;
          top: 0;
          width: 100%;
          pointer-events: none;
          order: 2;
          z-index: 10;
          transition: background .2s ease-in-out;
          box-sizing: border-box;
          overflow: hidden;
          white-space: nowrap;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-options:focus .yotpo-radio-and-dropdown-label {
          position: relative;
          pointer-events: all;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-options > .yotpo-radio-and-dropdown-option {
          opacity: 0;
          position: absolute;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-and-dropdown-label:hover {
          background: ${widgetState.customizations.styles.selectedRadio.dropdownHoverColor};
          cursor: pointer;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-and-dropdown-option:checked + .yotpo-radio-and-dropdown-label {
          order: 1;
          z-index: 20;
          background: ${widgetState.customizations.styles.selectedRadio.dropdownBackgroundColor};
          border-top: none;
          position: relative;
          cursor: auto;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-and-dropdown-option:checked + .yotpo-radio-and-dropdown-label:after {
          content: '';
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid ${widgetState.customizations.styles.colors.text.primary};
          position: absolute;
          right: 10px;
          top: calc(50% - 3px);
          pointer-events: none;
          z-index: 30;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-and-dropdown-option:checked + .yotpo-radio-and-dropdown-label:before {
          position: absolute;
          right: 0;
          height: 40px;
          width: 40px;
          content: '';
          background: ${widgetState.customizations.styles.selectedRadio.dropdownBackgroundColor};
        }
    </style>`
}
